import React from 'react';
import { connect } from 'react-redux';
import { actions } from '../../store';
import { Button, Card, CardActions, CardContent, CardHeader, TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import getPermissions from 'config/getPermissions';
import svc from 'svc';
import { memoize } from "lodash";



const styles = theme => ({
	card: {
		width: '50%',
		maxWidth: 600,
		marginTop: 24,
		margin: 'auto',
	},
	textField: {
		width: '100%',
	},
	button: {
		width: '100%',
	},
	progress: {
		width: '100%',
	},
	resetTitle: {
		marginTop: theme.spacing.unit * 8,
	},
});

//const url = 'ws://connect.tiger-sheep.com:8111';
//const url = 'ws://192.168.0.22:8111';
const url = process.env.REACT_APP_WS_URL;

function getAppData() {
	let lastHash = localStorage.appDataHash || null;
	let data = null;

	try {
		data = JSON.parse(localStorage.appData);
	} catch (err) {
		lastHash = null;
	}

	return svc.send('app', { method: 'getOptions', lastHash }).then(res => {
		if ( res.payload.hash === lastHash && !res.payload.data ) {
			return data;
		}

		localStorage.setItem('appData', JSON.stringify(res.payload.data));
		localStorage.setItem('appDataHash', res.payload.hash);

		return res.payload.data;
	}).catch(err => {
		console.error('Failed to get app data', err);
		return {};
	});
}



class LoginPage extends React.PureComponent {
	state = {
		username: '',
		password: '',
		userError: false,
		passError: false,
		requireReset: false,
		newPass1: '',
		newPass2: '',
		pending: false,
	};


	broadcastHandler = ( message ) => {
		let data = message.payload.msg;

		if ( !data.msg || typeof data.msg !== 'string' ) return false;
		if ( !data.title || typeof data.title !== 'string' ) return false;

		this.props.setLayout({
			broadcastTitle: data.title,
			broadcastText: data.msg,
			broadcastOpen: true,
		});
	};


	componentDidMount = () => {
		const { auth } = this.props;
		let retry = !!auth.token && !!auth.sid;
		if ( !retry ) {
			return false;
		}

		let res;
		this.props.setAuth({
			pending: true,
			resumePending: true,
		});

		svc.sessionSet(auth.sid, auth.token, url).then(( result ) => {
			res = result;
			return getAppData();
		}).then(appData => {
			let UserName = `${res.payload.FirstName} ${res.payload.LastName}`.trim();
			let UserInitials = `${res.payload.FirstName.substr(0, 1)}${res.payload.LastName.substr(0, 1)}`;
			if ( !UserName ) {
				UserName = 'Mystery User';
				UserInitials = ':)';
			}

			let userGroups = (res.payload.UserGroup || '').split(',').map(group => {
				return group.trim().toLowerCase();
			});
			let permissions = getPermissions(userGroups);

			if ( permissions.globalService ) window.svc = svc;

			this.props.setAppData({
				...appData,
				UserSlpCode: res.payload.SlpCode || null,
				UserEmpID: res.payload.EmpID || null,
				UserID: res.payload.UserID,
				UserGroup: userGroups,
				UserName,
				UserInitials,
				DefaultWhs: res.payload.DefaultWhs,
			});

			this.props.setAuth({
				pending: false,
				resumePending: false,
				token: res.payload.token,
				sid: res.payload.session,
				authenticated: true,
				permissions: permissions,
			});

			svc.addHandler('broadcastMessage', this.broadcastHandler);

			return true;
		}).catch(( err ) => {
			this.props.setAuth({
				pending: false,
				resumePending: false,
				token: null,
				sid: null,
				authenticated: false,
			});

			return false;
		});
	};


	validateCredentials = () => {
		let user = this.state.username,
			pass = this.state.password;
		let errors = {
			userError: false,
			passError: false,
		};

		if ( user.trim().length < 3 ) {
			errors.userError = true;
		}

		if ( pass.trim().length < 8 ) {
			errors.passError = true;
		}

		this.setState(errors);

		return !errors.userError && !errors.passError;
	};

	handleKeyPress = ( e ) => {
		if ( e.key === 'Enter' ) {
			return this.checkLogin();
		}
	};


	handleUpdate = memoize(name => e => {
		this.setState({ [ name ]: e.target.value });
	});


	checkLogin = () => {
		if ( !this.validateCredentials() ) {
			return false;
		}

		if ( this.state.requireReset && (this.state.newPass1 !== this.state.newPass2) ) {
			this.props.notify('New password fields must match');
			return false;
		}

		let res;

		let authObj = {
			user: this.state.username,
			pass: this.state.password,
		};

		if ( this.state.requireReset ) {
			authObj.props = { newPass: this.state.newPass1 };
		}

		this.setState({ pending: true });

		svc.send('auth', authObj).then(( result ) => {
			res = result;
			return getAppData();
		}).then(appData => {
			this.setState({ pending: false });
			this.setState({ pending: false });
			let UserName = `${res.payload.FirstName} ${res.payload.LastName}`.trim();
			let UserInitials = `${res.payload.FirstName.substr(0, 1)}${res.payload.LastName.substr(0, 1)}`;
			if ( !UserName ) {
				UserName = 'Mystery User';
				UserInitials = ':)';
			}

			let userGroups = (res.payload.UserGroup || '').split(',').map(group => {
				return group.trim().toLowerCase();
			});
			let permissions = getPermissions(userGroups);

			if ( permissions.globalService ) window.svc = svc;

			this.props.setAppData({
				...appData,
				UserSlpCode: res.payload.SlpCode || null,
				UserEmpID: res.payload.EmpID || null,
				UserID: res.payload.UserID,
				UserGroup: userGroups,
				UserName,
				UserInitials,
				DefaultWhs: res.payload.DefaultWhs,
			});

			this.props.setAuth({
				pending: false,
				token: res.payload.token,
				sid: res.payload.session,
				authenticated: true,
				permissions: permissions,
			});

			svc.addHandler('broadcastMessage', this.broadcastHandler);

			return true;
		}).catch(( err ) => {
			this.setState({ pending: false });

			if ( err.status === 401 ) {
				this.setState({
					userError: true,
					passError: true,
				});

				this.props.notify(err.msg);
			} else if ( err.status === 204 ) {
				this.setState({
					userError: false,
					passError: false,
					requireReset: true,
				});
			}

			return false;
		});
	};


	render() {
		const classes = this.props.classes;

		if ( this.props.auth.resumePending ) {
			return null;
		}

		return (
			<Card className={classes.card}>
				<CardHeader
					title="User Login"
					subheader="Enter your username and password"
				/>

				<CardContent>
					<TextField
						label="Username"
						className={classes.textField}
						type="text"
						margin="normal"
						value={this.state.username}
						onChange={this.handleUpdate('username')}
						error={this.state.userError}
						onKeyPress={this.handleKeyPress}
						disabled={this.state.requireReset}
					/>
					<TextField
						label="Password"
						className={classes.textField}
						type="password"
						margin="normal"
						value={this.state.password}
						onChange={this.handleUpdate('password')}
						error={this.state.passError}
						onKeyPress={this.handleKeyPress}
						disabled={this.state.requireReset}
					/>

					{this.state.requireReset &&
					<div>
						<Typography variant="subtitle1" className={classes.resetTitle}>
							Password Reset Required. Please enter your new password.
						</Typography>
						<TextField
							label="New Password"
							className={classes.textField}
							type="password"
							margin="normal"
							value={this.state.newPass1}
							onChange={this.handleUpdate('newPass1')}
							error={!!(this.state.newPass1.length && this.state.newPass1.length < 8)}
							onKeyPress={this.handleKeyPress}
						/>

						<TextField
							label="Re-enter New Password"
							className={classes.textField}
							type="password"
							margin="normal"
							value={this.state.newPass2}
							onChange={this.handleUpdate('newPass2')}
							error={!!(this.state.newPass2.length && this.state.newPass2 !== this.state.newPass1)}
							onKeyPress={this.handleKeyPress}
						/>
					</div>
					}
				</CardContent>

				<CardActions>
					<Button
						variant="contained"
						color="primary"
						className={classes.button}
						onClick={this.checkLogin}
						disabled={this.state.pending}
					>
						Log In
					</Button>
				</CardActions>
			</Card>
		)
	}

}



const mapStateToProps = state => {
	return {
		auth: state.auth,
	}
};


const mapDispatchToProps = dispatch => {
	return {
		setAuth: ( data ) => {
			dispatch(actions.auth.setAuth(data));
		},
		setAppData: ( data ) => {
			dispatch(actions.appData.setAppData(data));
		},
		notify: ( text, duration = 3500 ) => {
			dispatch(actions.layout.notify(text, duration));
		},
		setLayout: ( data ) => {
			dispatch(actions.layout.setState(data));
		},
	}
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LoginPage));

